import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'pl-use-sirius',
  template: '<p>Setting Sirius mode...</p>',
})
export class UseSiriusComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    const value = this.route.snapshot.queryParamMap.get('value');
    const validValues = ['1', '0'];
    if (value !== null && validValues.includes(value.toLowerCase())) {
      localStorage.setItem('USE_SIRIUS', value);
      // Reload the page and redirect to root after setting value
      // This is necessary to ensure the new value is applied
      window.location.href = '/';
    } else {
      // If no value provided or not valid, just redirect to home
      this.router.navigate(['/']);
    }
  }
}
